import { useState } from "react";
import { getCarrierBrand } from "../lib/carrier-brand";

interface Props {
  carrier: string;
  displayName: string;
  /** Self-hosted logo asset path, e.g. "/carrier-logos/royal-mail.svg". Falls back to a colour-coded initials badge when omitted or if it fails to load. */
  logoSrc?: string;
  size?: number;
}

export default function CarrierBadge({ carrier, displayName, logoSrc, size = 32 }: Props) {
  const [failed, setFailed] = useState(false);
  const brand = getCarrierBrand(carrier);

  if (logoSrc && !failed) {
    return (
      <img
        src={logoSrc}
        alt={displayName}
        width={size}
        height={size}
        className="carrier-badge carrier-badge-logo"
        style={{ width: size, height: size }}
        onError={() => setFailed(true)}
      />
    );
  }

  return (
    <span
      className="carrier-badge"
      aria-hidden="true"
      style={{ width: size, height: size, background: brand.color, color: brand.textColor, fontSize: size * 0.34 }}
    >
      {brand.initials}
    </span>
  );
}
